import { animate, state, style, transition, trigger } from '@angular/animations'

export const expandCollapseSignerCard = trigger('expandCollapse', [
  state('collapsed', style({ maxHeight: '0px' })),
  state('expanded', style({ maxHeight: '100vh' })),
  transition('collapsed => expanded', [animate('400ms ease-out', style({ maxHeight: '100vh' }))]),
  transition('expanded => collapsed', [animate('400ms cubic-bezier(0, 1, 0, 1)', style({ maxHeight: '0px' }))]),
])